import { useUserContext } from './hooks';
const useFeatureGate = (featureId) => {
    const { enabledFeatures } = useUserContext();
    const isEnabled = enabledFeatures.includes(featureId);
    return isEnabled;
};
export default useFeatureGate;
//# sourceMappingURL=useFeatureGate.js.map